module.exports = __webpack_public_path__ + "static/airflow-pinwheel-b61ca4c02d7d1052d41431cba71a8af2.png";